module.exports = __webpack_public_path__ + "static/media/payment-banner.00af091e.jpg";